import { Instagram, ArrowUpRight } from "lucide-react";

export const EmptyState = ({ url, unavailable }) => (
  <div data-testid="feed-empty-state" className="relative border border-dashed border-[var(--line)] px-8 py-24 md:py-32 text-center">
    <Instagram className="mx-auto h-8 w-8 text-[var(--smoke)]" />
    <h3 className="font-display text-3xl md:text-4xl font-light mt-6">
      {unavailable ? "The feed is taking a breather." : "The first story is on its way."}
    </h3>
    <p className="mt-4 text-[var(--ash)] max-w-md mx-auto text-sm md:text-base">
      {unavailable
        ? "We couldn't reach Instagram just now. Check back shortly, or catch the posts directly."
        : "New posts appear here automatically the moment they go live on Instagram."}
    </p>
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      data-testid="empty-follow-link"
      className="mt-8 inline-flex items-center gap-2 text-sm text-[var(--volt)] underline-offset-8 hover:underline"
    >
      Open @hostnode.cloud <ArrowUpRight className="h-4 w-4" />
    </a>
  </div>
);
